import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";

/**
 * 예약 퍼널 단계별 PostHog 이벤트 훅
 *
 * 퍼널: booking_page_viewed → booking_form_submitted →
 *       booking_rules_viewed → booking_summary_viewed → booking_completed
 */
export const useBookingAnalytics = (storeId: string) => {
    const posthog = usePostHog();

    const captureBookingFormSubmitted = useCallback(
        (props: { adults: number; kids: number; date: string; time: string }) => {
            posthog.capture("booking_form_submitted", { store_id: storeId, ...props });
        },
        [posthog, storeId],
    );

    const captureRulesViewed = useCallback(() => {
        posthog.capture("booking_rules_viewed", { store_id: storeId });
    }, [posthog, storeId]);

    const captureSummaryViewed = useCallback(() => {
        posthog.capture("booking_summary_viewed", { store_id: storeId });
    }, [posthog, storeId]);

    const captureBookingCompleted = useCallback(
        (props: { is_auto_confirmed: boolean; adults: number; kids: number }) => {
            posthog.capture("booking_completed", { store_id: storeId, ...props });
        },
        [posthog, storeId],
    );

    const captureCancelled = useCallback(() => {
        posthog.capture("booking_cancelled", { store_id: storeId });
    }, [posthog, storeId]);

    return {
        captureBookingFormSubmitted,
        captureRulesViewed,
        captureSummaryViewed,
        captureBookingCompleted,
        captureCancelled,
    };
};
